<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="mb-0">
            <i class="fa fa-bell-o"></i>
            أرشيف إشعارات التطبيق
          </h4>
          <button class="btn btn-sm btn-outline-primary" @click="load()" :disabled="loading">
            <i class="fa fa-refresh"></i> تحديث
          </button>
        </div>
        <div class="card-body">
          <div class="alert alert-info g mb-2 note">
            <i class="fa fa-info-circle"></i>
            هذه الصفحة خاصة بإشعارات <b>تطبيق أولياء الأمور فقط</b> خلال آخر 30 يوماً.
            أمام كل إشعار: <b>تم الإرسال</b> ثم <b>تم الاستلام</b> (وصل لجوال ولي الأمر) ثم <b>تمت القراءة</b> (فتحه).
          </div>

          <div class="row tiles">
            <div class="col-6 col-md-4 col-lg-2 g" v-for="t in tiles" :key="t.key">
              <div class="tile" :class="t.cls">
                <span class="v">{{ t.value }}</span>
                <span class="l">{{ t.label }}</span>
              </div>
            </div>
          </div>

          <div class="row filters">
            <div class="col-12 col-md-5 g">
              <input type="text" class="form-control" v-model="q" placeholder="ابحث باسم الطالب أو رقمه أو نص الإشعار" @keyup.enter="page = 0; load()">
            </div>
            <div class="col-8 col-md-4 g">
              <select class="form-control" v-model="filter" @change="page = 0; load()">
                <option value="">كل الإشعارات</option>
                <option value="delivered">تم الاستلام</option>
                <option value="not_delivered">لم يُستلم بعد</option>
                <option value="read">تمت القراءة</option>
                <option value="not_read">لم يُقرأ بعد</option>
              </select>
            </div>
            <div class="col-4 col-md-3 g">
              <button class="btn btn-primary btn-block" @click="page = 0; load()"><i class="fa fa-search"></i> بحث</button>
            </div>
          </div>

          <div class="text-center g" v-if="loading && !rows.length">
            <img :src="require('@/assets/images/loading.svg')" alt="" width="50">
          </div>
          <div class="text-center text-muted g" v-else-if="!rows.length">
            لا توجد إشعارات لأولياء الأمور في آخر 30 يوماً.
          </div>

          <div class="table-responsive" v-else>
            <table class="table table-hover table-bordered push-table">
              <thead>
                <tr>
                  <th>التاريخ</th>
                  <th>الطالب</th>
                  <th>الإشعار</th>
                  <th>الحالة</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in rows" :key="row._id">
                  <td class="nowrap">{{ row.date }}</td>
                  <td>
                    <div v-for="(s, i) in row.students" :key="i" class="student">
                      <b>{{ s.name || s.number }}</b>
                      <small class="text-muted d-block" v-if="s.classname">{{ s.classname }}<span v-if="s.classroom"> - {{ s.classroom }}</span></small>
                    </div>
                  </td>
                  <td class="text">
                    <span class="kind" v-if="kindLabel(row.kind)">{{ kindLabel(row.kind) }}</span>
                    <b class="d-block">{{ row.title }}</b>
                    <span class="text-muted" v-if="row.body">{{ row.body }}</span>
                  </td>
                  <td class="steps-cell">
                    <div class="steps">
                      <span v-for="st in steps(row)" :key="st.key" class="step" :class="st.cls" v-b-tooltip.hover.top="st.tip">
                        <i :class="st.icon"></i> {{ st.label }}
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="pager g" v-if="pages > 1">
            <button class="btn btn-sm btn-outline-secondary" :disabled="page == 0 || loading" @click="page--; load()">
              <i class="fa fa-arrow-right"></i> السابق
            </button>
            <span class="text-muted">صفحة {{ page + 1 }} من {{ pages }} ({{ total }} إشعار)</span>
            <button class="btn btn-sm btn-outline-secondary" :disabled="page + 1 >= pages || loading" @click="page++; load()">
              التالي <i class="fa fa-arrow-left"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

const OLD_APP = 'لا يمكن معرفة الاستلام والقراءة لأن ولي الأمر لم يحدّث تطبيق ولي الأمر لآخر إصدار.';

export default {
  directives: { 'b-tooltip': VBTooltip },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      rows: [],
      total: 0,
      page: 0,
      pages: 0,
      q: '',
      filter: '',
      loading: false,
      summary: {},
    }
  },
  computed: {
    tiles() {
      var s = this.summary || {};
      return [
        { key: 'total', label: 'إجمالي الإشعارات', value: s.total || 0, cls: '' },
        { key: 'sent', label: 'تم الإرسال', value: s.sent || 0, cls: 'ok' },
        { key: 'delivered', label: 'تم الاستلام', value: s.delivered || 0, cls: 'ok' },
        { key: 'read', label: 'تمت القراءة', value: s.read || 0, cls: 'read' },
        { key: 'unknown', label: 'تطبيق غير محدّث', value: s.unknown || 0, cls: 'muted' },
        { key: 'bad', label: 'لم يصل كإشعار', value: (s.failed || 0) + (s.off || 0), cls: 'bad' },
      ];
    },
  },
  created() {
    if (!checkPer('archive') && !checkPer('students|archive')) {
      this.$router.push('/NotPermitted');
      return;
    }
    this.load();
  },
  methods: {
    load() {
      var g = this;
      g.loading = true;
      $.post(api + '/user/push/archive', {
        jwt: this.user.jwt,
        page: this.page,
        q: this.q,
        filter: this.filter,
      }).then(function (r) {
        g.loading = false;
        if (r.status != 100) return alert(r.response, 200);
        g.rows = r.response.rows;
        g.total = r.response.total;
        g.pages = r.response.pages;
        g.summary = r.response.summary;
      }).fail(function () {
        g.loading = false;
        alert('تعذر الاتصال بالسيرفر', 200);
      });
    },
    kindLabel(kind) {
      return {
        'school.notice': 'إشعار المدرسة',
        chat: 'محادثة',
      }[kind] || '';
    },
    // Three marks per push: sent → delivered → read.
    steps(row) {
      var sent;
      if (row.status == 'failed') {
        sent = { key: 's', cls: 'bad', icon: 'fa fa-times', label: 'لم يُرسل', tip: 'لم يعد جوال ولي الأمر مسجلاً للإشعارات (قد يكون التطبيق محذوفاً).' };
      } else if (row.status == 'off') {
        sent = { key: 's', cls: 'warn', icon: 'fa fa-bell-slash', label: 'الإشعارات مقفلة', tip: 'ولي الأمر أوقف الإشعارات في جواله؛ يجده داخل التطبيق في قائمة الإشعارات.' };
      } else if (row.status == 'queued') {
        sent = { key: 's', cls: 'wait', icon: 'fa fa-clock-o', label: 'جاري الإرسال', tip: 'في طابور الإرسال.' };
      } else {
        sent = { key: 's', cls: 'ok', icon: 'fa fa-check', label: 'تم الإرسال', tip: 'أُرسل ' + row.date };
      }

      var unknown = !row.receipts;
      var done = row.status == 'failed';
      var delivered = row.delivered_at
        ? { key: 'd', cls: 'ok', icon: 'fa fa-check-circle', label: 'تم الاستلام', tip: 'وصل لجوال ولي الأمر ' + row.delivered_at }
        : done
          ? { key: 'd', cls: 'unknown', icon: 'fa fa-minus', label: 'لم يُستلم', tip: 'لم يُرسل الإشعار.' }
          : row.status == 'off'
            ? { key: 'd', cls: 'unknown', icon: 'fa fa-minus', label: 'لم يظهر كإشعار', tip: 'الإشعارات مقفلة في جوال ولي الأمر.' }
            : unknown
              ? { key: 'd', cls: 'unknown', icon: 'fa fa-question-circle-o', label: 'الاستلام', tip: OLD_APP }
              : { key: 'd', cls: 'wait', icon: 'fa fa-clock-o', label: 'لم يُستلم بعد', tip: 'لم يصل بعد (قد يكون الجوال مغلقاً أو بلا إنترنت).' };

      var read = row.read_at
        ? { key: 'r', cls: 'read', icon: 'fa fa-eye', label: 'تمت القراءة', tip: 'فتحه ولي الأمر ' + row.read_at }
        : done
          ? { key: 'r', cls: 'unknown', icon: 'fa fa-minus', label: 'لم يُقرأ', tip: 'لم يُرسل الإشعار.' }
          : unknown
            ? { key: 'r', cls: 'unknown', icon: 'fa fa-question-circle-o', label: 'القراءة', tip: OLD_APP }
            : { key: 'r', cls: 'wait', icon: 'fa fa-eye-slash', label: 'لم يُقرأ بعد', tip: 'لم يفتحه ولي الأمر بعد.' };

      return [sent, delivered, read];
    },
  },
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.note {
  padding: 10px 14px;
  line-height: 1.9;
}
.tile {
  border: 1px solid #D5DAE3;
  border-radius: 12px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.tile .v {
  font-size: 22px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #0F1733;
}
.tile .l {
  font-size: 12px;
  color: #667085;
}
.tile.ok .v { color: #067647; }
.tile.read .v { color: #1D4ED8; }
.tile.muted .v { color: #98A2B3; }
.tile.bad .v { color: #B42318; }
.push-table td {
  vertical-align: middle;
}
.push-table .nowrap {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.push-table .text {
  min-width: 220px;
  max-width: 420px;
}
.push-table td:nth-child(2) {
  min-width: 170px;
}
.student + .student {
  margin-top: 6px;
}
.kind {
  display: inline-block;
  font-size: 11px;
  padding: 0 8px;
  border-radius: 999px;
  background: #EEF3FF;
  color: #1D4ED8;
  margin-bottom: 3px;
}
.steps-cell {
  min-width: 330px;
}
.steps {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.step {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid transparent;
  cursor: default;
}
.step.ok { background: #E7F6EE; color: #067647; }
.step.read { background: #E8EEFD; color: #1D4ED8; }
.step.wait { background: #F2F4F7; color: #475467; }
.step.warn { background: #FEF4E6; color: #B54708; }
.step.bad { background: #FDEDE8; color: #B42318; }
.step.unknown {
  background: transparent;
  color: #98A2B3;
  border: 1px dashed #C4CBD6;
  opacity: .85;
}
.pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
</style>
